function readEventMs(log) {
  let ts = log?.processedAt || log?.orderData?.timestamp || log?.timestamp
  if (!ts) return null
  if (typeof ts === 'number' && ts < 10000000000) ts *= 1000
  const ms = new Date(ts).getTime()
  return Number.isFinite(ms) ? ms : null
}

function utcDayKey(ms) {
  const date = new Date(ms)
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${date.getUTCFullYear()}-${month}-${day}`
}

const CLOSE_LONG_PURPOSES = new Set(['closeLong', 'manualSell', 'sellSpot'])
const CLOSE_SHORT_PURPOSES = new Set(['closeShort', 'hedgeBuy', 'closeHedge'])

export function computeTodayProfit(logs, nowMs = Date.now()) {
  const todayKey = utcDayKey(nowMs)
  let realizedPnl = 0
  let closeLongCount = 0
  let closeShortCount = 0

  for (const log of logs || []) {
    if (!log || log.processed === false) continue
    const ms = readEventMs(log)
    if (ms != null && utcDayKey(ms) !== todayKey) continue

    if (CLOSE_LONG_PURPOSES.has(log.purpose)) closeLongCount += 1
    if (CLOSE_SHORT_PURPOSES.has(log.purpose)) closeShortCount += 1

    const pnl = log.metrics?.pnl
    if (pnl != null && pnl !== 0) realizedPnl += Number(pnl) || 0
  }

  return { realizedPnl, closeLongCount, closeShortCount }
}
